import { getItemByKeysUtil, getMergeSchemaUtil } from "qjumpers.common.ui";

export function createEnumItemsDefinition(key, arr, nameProperty = "name", idProperty = "id", uniqueItems = true) {
  return {
    [key]: {
      type: "array",
      items: {
        type: "string",
        enum: arr.map((o) => o[idProperty]),
        enumNames: arr.map((o) => o[nameProperty]),
      },
      uniqueItems,
    },
  };
}

export function updateApplicationInternalUiSchema(companyName, uiSchema, translator) {
  if (!companyName) return;

  let property = { "ui:customTitle": translator("Form.Application.Internal.Title", { company: companyName }) };
  let array = [];
  var keys = [];

  keys.push("internal");
  getItemByKeysUtil(uiSchema, array, keys);
  array.forEach((a) => {
    a.schema = getMergeSchemaUtil(a, property);
  });
}
